/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2022-10-08 15:32:08
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2024-01-26 14:36:26
 * @FilePath: \xm-runing-main\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import 'core-js/modules/es.array.find'
import 'core-js/modules/es.array.find-index'
import 'core-js/modules/es.array.find-last'
import 'core-js/modules/es.array.find-last-index'
import 'core-js/modules/es.array.to-reversed'
import 'core-js/modules/es.array.to-sorted'
import 'core-js/modules/es.array.to-spliced'

import 'core-js/modules/es.array.at'
import 'core-js/modules/esnext.string.at'
import 'core-js/modules/es.string.replace-all'
import 'core-js/web/url'

import now from '~build/time'
import {
  sha
} from '~build/git'

import {
  name
} from '~build/package'

import 'virtual:windi-base.css';
import 'virtual:windi-components.css';
import 'virtual:windi-utilities.css';
// Register icon sprite
import 'virtual:svg-icons-register';
import '@/design/index.less';
import App from './App.vue';
import { createApp } from 'vue';
import { initAppConfigStore } from '@/logics/initAppConfig';
import { setupErrorHandle } from '@/logics/error-handle';
import { router, setupRouter } from '@/router';
import { setupStore } from '@/store';
import { setupGlobDirectives } from '@/directives';
import { registerGlobComp } from '@/components/registerGlobComp';
import { setupVxeTable } from '@/utils/xmCom/setupVxeTable';
import { setupRouterGuard } from '@/router/guard';
// 注册乾坤
import startQiankun from './migo';
import { loadSystem } from '@/utils/xmCom/loadSystem';
import {StorageUtils} from 'xmgoing-utils';
import { Persistent } from '@/utils/cache/persistent';
import { PROJ_CFG_KEY } from '@/enums/cacheEnum';
import { getLayoutConfig } from '@/api/sys/portalSpace';
import {getSystemConfigProp, QueryCommand} from 'xmgoing-server';
import i18n from './i18n';
import "@/assets/less/antd.user.less";
import {initLayout} from "@/store/commonUtils";
import draggableDirective from'./utils/draggableDirective.js';
import dayjs from 'dayjs';
import {checkAppVersionAndReload} from '@/utils/checkAppVersion';
loadSystem();
async function bootstrap() {
  const app: any = createApp(App);
  // Multilingual configuration
  // 多语言配置
  // Asynchronous case: language files may be obtained from the server side
  // 异步案例：语言文件可能从服务器端获取
  app.use(i18n);
  // Configure store
  // 配置 store
  setupStore(app);
  app.directive('draggable',draggableDirective);
  // Initialize internal system configuration
  // 初始化内部系统配置（含 layoutId / 主题，须在 setupStore 之后）
  initAppConfigStore();

  // Register global components
  // 注册全局组件
  registerGlobComp(app);

  // 注册 vxe-table（按需加载）
  setupVxeTable(app);

  // Configure routing
  // 配置路由
  setupRouter(app);

  // router-guard
  // 路由守卫
  setupRouterGuard(router);

  // Register global directive
  // 注册全局指令
  setupGlobDirectives(app);

  // Configure global error handling
  // 配置全局错误处理
  setupErrorHandle(app);

  // https://next.router.vuejs.org/api/#isready
  // await router.isReady();
  // 启动乾坤
  startQiankun();
  app.mount('#app');
  window.appObj = app;
  app.preview = true;
  window.appObj.preview = true;
}

//加载项目配置信息
async function loadProjectConfig(backFun,isNewUser,position) {
  //先从缓存中获取，如果存在缓存 则执行
  if (StorageUtils.getSessionItem('setPortal') === 'true') {
    StorageUtils.addSessionItem('defaultLayoutConfig', null);
  }
  const cachedLayoutConfig = StorageUtils.getSessionItem('defaultLayoutConfig');
  if (cachedLayoutConfig && cachedLayoutConfig !== 'null') {
    try {
      const configObj: any = JSON.parse(cachedLayoutConfig + '');
      const systemConfigStr = StorageUtils.getSessionItem('systemConfig');
      const systemConfig = systemConfigStr && systemConfigStr !== 'null'
        ? JSON.parse(systemConfigStr + '')
        : {};
      initLayout(configObj, systemConfig,isNewUser,position);
      Persistent.setLocal(PROJ_CFG_KEY, configObj, true);
      backFun && backFun();
      return;
    }catch (e){
      console.error('[loadProjectConfig] 读取本地布局缓存失败，改为请求接口', e);
      StorageUtils.removeSessionItem('defaultLayoutConfig');
    }
  }
  try {
    //如果缓存中不存在 才进行查询
    const { configJson, systemConfig } = await getLayoutConfig('defaultLayout');
    let configObj;
    if (configJson) {
      StorageUtils.addSessionItem('defaultLayoutConfig', configJson);
      configObj = JSON.parse(configJson);
      Persistent.setLocal(PROJ_CFG_KEY, configObj, true);
    }
    if (systemConfig) {
      if (typeof systemConfig === 'object') {
        StorageUtils.addSessionItem('systemConfig', JSON.stringify(systemConfig));
      } else {
        StorageUtils.addSessionItem('systemConfig', systemConfig);
      }
      initLayout(configObj, systemConfig,isNewUser,position);
    } else {
      initLayout(configObj, {}, isNewUser, position);
    }
    //缓存退出端口信息：优先使用当前访问端口，域名标准端口访问时不缓存业务端口
    const outSystemPortal = location.port || '';
    StorageUtils.addItem('outSystemPortal',outSystemPortal);
    const devPortal = getSystemConfigProp('devPortal');
    StorageUtils.addSessionItem('devPortal',devPortal);
    backFun && backFun();
  } catch (e) {
    console.log(e);
  }
}

/**
 * 登录前  先加载当前用户信息
 */
let queryCommand = new QueryCommand({ url: '/api/pe-portal/users/getUserInfo', method: 'GET' });
let params = {};
queryCommand.executeQueryPromise({ params }).then(async (des) => {
  const { id,isNewUser,position }: any = des;
  if (des) {
    StorageUtils.addSessionItem(id + '_userObj', JSON.stringify(des));
    StorageUtils.addSessionItem('curUserJson', JSON.stringify(des));
  }
  const canContinue = await checkAppVersionAndReload();
  if (!canContinue) {
    return;
  }
  loadProjectConfig(bootstrap,isNewUser,position);
});

console.log(`
  name: ${name}
  build time: ${dayjs(now).format('YYYY-MM-DD HH:mm:ss')}
  commit: ${sha}
`);
